import { Grid } from '@mui/material';
import React from 'react';
import styles from './styles.module.css';
import { DataGrid, GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { getSlideField } from 'pages/Conversations/components/SlidesEditor/utils';
import { Slide } from 'pages/Conversations/components/SlidesEditor/_data';
import { SlideSubtitle } from '../slide-subtitle/slide-subtitle';

export type StrategySelectionProps = [
  {
    field: 'modelSetHoldings';
    label: string;
    value: any[];
    type: 'modelSetHoldings';
  },
  {
    field: 'table';
    label: string;
    value: any[];
    type: 'editableTextarea';
  },
];

export const StrategySelection = React.memo(
  ({ slide }: { slide: Slide<StrategySelectionProps> }): React.ReactElement => {
    const holdings = React.useMemo(
      () =>
        slide.content[1].value.flatMap((holding: any) =>
          holding.holdings.map((h: any, index: number) => ({
            id: index,
            ...h,
          })),
        ),
      [slide.content],
    );

    return (
      <Grid container direction="row" className={styles.container}>
        <Grid item xs={12}>
          <SlideSubtitle>Strategist Selection</SlideSubtitle>
          <DataGrid
            rows={holdings}
            columns={columns}
            hideFooter
            hideFooterPagination
            hideFooterSelectedRowCount
            disableColumnMenu
            disableColumnSelector
            disableColumnFilter
            getRowId={row => row.id}
            getRowHeight={() => 'auto'}
            sx={{
              mt: 2,
              height: 'fit-content',
              '& .MuiDataGrid-columnHeader': {
                backgroundColor: '#f0f0f0',
                whiteSpace: 'normal',
                height: 'auto',
                minHeight: '50px !important',
                '& .MuiDataGrid-columnHeaderTitleContainer': {
                  whiteSpace: 'normal',
                  lineHeight: 'normal',
                  height: 'auto',
                  color: '#86858B',
                },
              },
              '& .MuiDataGrid-cell': {
                fontSize: '11px',
                whiteSpace: 'normal !important',
                lineHeight: 'normal',
                display: 'flex',
                alignItems: 'center',
                padding: '8px',
                minHeight: '50px !important',
                height: 'auto !important',
                maxHeight: 'none !important',
              },
              '& .MuiDataGrid-row': {
                maxHeight: 'none !important',
                height: 'auto !important',
              },
            }}
          />
        </Grid>
      </Grid>
    );
  },
  (prevProps, nextProps) => {
    const prevRows = getSlideField(prevProps.slide, 'modelSetHoldings')?.value;
    const nextRows = getSlideField(nextProps.slide, 'modelSetHoldings')?.value;
    return JSON.stringify(prevRows) === JSON.stringify(nextRows);
  },
);

const DescriptionCell = (params: GridRenderCellParams) => {
  return (
    <div
      style={{
        whiteSpace: 'normal',
        lineHeight: '1.5',
        padding: '8px 0',
      }}
    >
      {params.value}
    </div>
  );
};

const columns: GridColDef[] = [
  { field: 'strategy', headerName: 'STRATEGY', flex: 1, sortable: false },
  {
    field: 'description',
    headerName: 'DESCRIPTION',
    flex: 2.5,
    renderCell: DescriptionCell,
    sortable: false,
  },
  {
    field: 'implementation',
    headerName: 'IMPLEMENTATION',
    flex: 1.5,
    sortable: false,
  },
  {
    field: 'main_purpose',
    headerName: 'MAIN PURPOSE',
    flex: 2.5,
    renderCell: DescriptionCell,
    sortable: false,
  },
];
